import React, { useState } from 'react';
import { Helmet } from "react-helmet";
import { useHistory } from 'react-router-dom';
import useSettingsContext from 'contexts/useSettingsContext';
import SettingsContext from 'contexts/SettingsContext';

import ValidationErrorCollection from 'validators/ValidationErrorCollection';

import CodeEntry from './CodeEntry';
import Step from 'components/Step/Step';
import Link from 'components/Link/Link';
import Button from 'components/Button/Button';
import SummaryTsandCs from 'components/SummaryTsandCs/SummaryTsandCs';


import KeyVisual from './KeyVisual';

import How1 from 'assets/images/campaign/how-1.png';
import How1_2x from 'assets/images/campaign/how-1@2x.png';
import How2 from 'assets/images/campaign/how-2.png';
import How2_2x from 'assets/images/campaign/how-2@2x.png';
import How4 from 'assets/images/campaign/how-4.png';
import How4_2x from 'assets/images/campaign/how-4@2x.png';
import How5 from 'assets/images/campaign/how-5.png';
import How5_2x from 'assets/images/campaign/how-5@2x.png';

import analyticsService from 'services/analyticsService';
import CountrySelect from './CountrySelect';

import './Home.scss';
import CountryCtaModal from './CountryCtaModal';

export default () => {
  const [settings, setSettings] = React.useContext(SettingsContext);
  let settingsState = useSettingsContext();
  let history = useHistory();
  let compState = settings.competitionStatus.openState;
  let compPhaseId = settings.competitionStatus.currentPhasePublicId;
  let competitionIsOpen = compState === "Open";
  let competitionIsNotStarted = compState === "NotStarted";
  let competitionIsClosed = compState === "Closed";
  const [showEntryModal, setShowEntryModal] = useState(false);
  const [showCountryModal, setShowCountryModal] = useState(!settings.country);
  const [showCountryCtaModal, setShowCountryCtaModal] = useState(false);
  let [validation, setValidation] = useState({
    errors: new ValidationErrorCollection(),
    acknowledged: false
  });

  const handleCountrySelected = (data) => {
    sessionStorage && sessionStorage.setItem('philadelphiaBrunch.country', data.country);
    settingsState.setCountry(data.country);
    setShowCountryModal(false);
  }

  const handleEnterNow = async () => {
    if (settings.country !== "ROI") {
      analyticsService.logEvent("enterCompetition", "ProofOfPurchase", {
        action: "OpenProofOfPurchaseModal",
        label: "open modal",
        value: "Open code entry modal"
      });

      setShowEntryModal(true);
    } else {
      analyticsService.logEvent("enterCompetition", "NoPurchaseNecessary", {
        action: "OpenRegistration"
      });      
      history.push("/registration");
    }
  }

  const renderSteps = (steps) => {
    return steps.map((step, index) => {
      return (
        <Step key={step.number} {...step} />
      )
    })
  }

  const renderEntryCta = (title) => {
    if (!settings.country) return null;

    return <Button
      wide
      type="submit"
      title={title ? title : "Enter Now"}
      onClick={handleEnterNow}
    />
  }

  const renderIntroMessage = (compState) => {
    switch (compState) {
      case 'Open':
        return <>
          <div className="home__intro home__intro--slim">
            <h2 className='type-h1'>WIN a brunch in New York for you and a friend!</h2>

            <div className="home__cta">
              {renderEntryCta("Enter here")}
            </div>

            <div className="home__intro-body">
              <p>
                You and your Philly-loving bestie could be our lucky WINNERS, whisked away on an unforgettable getaway with flights, hotel, spends, and of course, an indulgent, cream-cheese-covered brunch in the heart of the city included!
              </p>
              <p>
                If you don't end up packing your bags for NYC, you can still WIN 1 of 10 luxury brunch bundles packed full of your Philly favourites, New York Bakery Co bagels, a retro-style toaster, AND {settings.country != "ROI" ? "£" : "€"}100 worth of takeaway vouchers!
              </p>
              <p>
                Either way, this is one win you won't want to miss a bite of!
              </p>
            </div>
          </div> 
        </>

      case 'NotStarted':
        return <>
          <div className="home__intro home__intro--slim">
            <h2 className='type-h2'>Patience, Philly lover, you're a bit early to...</h2>
            <h2 className='type-h1'>WIN a brunch in New York for you and a friend!</h2>
            <div className='home__intro-body'>
              <p>
                Come back on 7th July for your chance to WIN an unforgettable trip to New York, spread across five unforgettable days, and topped with that dreamy brunch experience!
              </p>
              <p>
                Not the NYC winner? No worries! We're also giving away 10 luxury brunch bundles filled with your favourite Philly snacks, and more mouthwatering goodies!
              </p>
              <p>
                So until then, try and contain your excitement, and feast your eyes on these Philly-smothered recipes that'll have your tastebuds brunchin' in no time!
              </p>
            </div>
          </div>

          <div className="home__cta">
            <Link
              analytics={{ evnt: "siteLink", category: "NotStartedPhaseIntroduction", action: "OpenPhiladelphiaUKWebsite" }}
              to="https://www.philadelphia.co.uk/recipes/" lozenge title="Dive into inspo" >Dive into inspo</Link>

          </div>
        </>

      case 'Closed':
        return <>
         <div className="home__intro">
            <h2 className='type-h1'>Closed for Brunch!</h2>
            <div className="home__intro-body">
              <p>
                Unfortunately, the competition has now ended, and our lucky winners are off to enjoy their deliciously creamy, brunchy prizes.
              </p>
              <p>
                But who says the brunch fun has to stop? Head over to our website for some irresistably Philly-inspired recipes and whip up your own dreamy brunch at home!
              </p>
            </div>
          </div>
          <div className="home__cta">
            <Link
              analytics={{ evnt: "siteLink", category: "ClosedPhaseIntroduction", action: "OpenPhiladelphiaUKWebsite" }}
              to="https://www.philadelphia.co.uk/recipes/" lozenge title="Dish up delish" >Dish up delish</Link>
            <Link
              analytics={{ evnt: "siteLink", category: "ClosedPhaseIntroduction", action: "OpenPhiladelphiaUKWebsite" }}
              to="https://www.philadelphia.co.uk/recipes/" lozenge title="Recipes with ease" >Recipes with ease</Link>
          </div>
        </>
    }
  }

  return (
    <div className="layout">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Home | Philadelphia - WIN a brunch in New York</title>
      </Helmet>
      {competitionIsOpen &&
        <>
          <CodeEntry
            show={showEntryModal}
            onDismiss={() => setShowEntryModal(false)}
            onEntry={() => history.push("/registration") }  
          />

          <CountrySelect
            show={showCountryModal}
            onCountrySelected={handleCountrySelected}
          />
        </>
      }

      {
        !competitionIsOpen && 
          <CountryCtaModal
            show={showCountryCtaModal}
            onDismiss={() => setShowCountryCtaModal(false)}
            competitionIsClosed={competitionIsClosed}
          /> 
      }

      <h1 className="visually-hidden">Philadelphia Original - WIN a brunch in New York</h1>

      <section className="layout-wrapper home__banner">
        <div className="home__banner-container">
          <div className="home__banner-content">
            <KeyVisual />
          </div>
        </div>
      </section>

      
        <section className={"layout-wrapper home__entrybar relative"}>
          <div className="layout-container layout-container--center">

            {renderIntroMessage(compState)}
            
          </div>
        </section>

      {
        (competitionIsOpen) &&
        <section className="layout-wrapper home__howto" id="how-to-play">
          <div className="layout-container layout-container--center ">
            <h2 className="type-h1">How does it work?</h2>
            <div className="home__steps">
            {
                
              (settings.country === "ROI") ?
                (
                  renderSteps([
                    { number: 1, title: "Fill in your details.", image: How4, image2x: How4_2x, alt: "Form Graphic." },
                    { number: 2, title: "You're now entered into the prize draw!", image: How5, image2x: How5_2x, alt: "Philadelphia brunch: Win a trip to New York", description: "The prize draw will take place after the competition ends on 30/09/2025" },
                  ])
                ) : (
                  renderSteps([
                    { number: 1, title: "Buy ANY participating Philly product", image: How1, image2x: How1_2x, alt: "Philadelphia spread"},
                    { number: 2, title: "Enter the barcode and batch code of your product.", image: How2, image2x: How2_2x, alt: "A barcode and batch code from a Philadelphia pack" },
                    { number: 3, title: "Fill in your details.", image: How4, image2x: How4_2x, alt: "Form Graphic." },
                    { number: 4, title: "You're now entered into the prize draw!", image: How5, image2x: How5_2x, alt: "Philadelphia brunch: Win a trip to New York", description: "The prize draw will take place after the competition ends on 30/09/2025" }
                  ])
                )
    
            }
            
            </div>
            <div className="home__cta">
              {renderEntryCta()}
            </div>
          </div>
        </section>
      }

      <SummaryTsandCs  />

    </div >
  );
}